import { ArchivedEntity } from '@texas/api/endpoints/archiveApi';
import { RequestOptionsWithBody } from '@texas/api/httpClient/types';
import { ArchiveTab } from './archiveTabs';

interface ArchiveRestoreArguments {
  path: string;
  options?: RequestOptionsWithBody;
}

const dedicatedRestoreResources = new Set([
  'article',
  'concept',
  'customer',
  'supplier',
  'user',
]);

export function getArchiveRestoreArguments(
  tab: ArchiveTab,
  entity: ArchivedEntity,
): ArchiveRestoreArguments {
  const path = `${tab.entityPath}/${encodeURIComponent(entity.id)}`;
  if (dedicatedRestoreResources.has(tab.resource)) {
    return { path: `${path}/restore` };
  }

  const data: Record<string, string | boolean> = { archived: false };
  if (tab.resource !== 'file') {
    data.name = entity.name;
  }
  if (entity.identifier) {
    data[
      tab.resource === 'country' || tab.resource === 'currency'
        ? 'code'
        : 'identifier'
    ] = entity.identifier;
  }

  return { path, options: { data } };
}
